import React from "react";

const BidsCard = () => {
	return (
		<div className="homepage__bidCard">
			<div className="homepage__bidCard__top">
				<div className="homepage__bidCard__avatar">
					<img src="" alt="" />
				</div>
				<div className="homepage__bidCard__details">
					<p className="homepage__bidCard__name">Cosmin Negoita</p>
					<p className="homepage__bidCard__verification">Verified</p>
				</div>
				<div>
					<p>&#36;US Dollar</p>
				</div>
			</div>
			<div className="homepage__bidCard__middle">
				<div className="homepage__bidCard__middle__prices">
					<p>Buy Rate</p>
					<p>₦3,540/$1</p>
				</div>

				<div className="homepage__bidCard__middle__prices">
					<p>Total Amount</p>
					<p>₦3,540</p>
				</div>
			</div>
			<div className="homepage__bidCard__bottom">
				<button>Access Bid</button>
			</div>
		</div>
	);
};

export default BidsCard;
